import { Injectable } from '@angular/core';

export const darkTheme = {
    'main-bg-color': '#343434',
    'color-yellow-pri': '#DED615',
    'color-yellow-sec': 'rgb(222,214,21,0.6)',
    'color-dark': '#000000',
    'font-color': '#FFFFFF',
    'border-line-color': 'rgb(255,255,255,0.3)',
    'background-title': 'rgb(0, 0, 0, 0.2)',
    'card-title-color': '#DED615',
    'bar-chart-title-color': '#DED615',
    'bar-chart-font-color': '#FFFFFF',
    'box-chart-line': 'rgb(255,255,255,0.3)',
    'box-table-bg': '#343434',
    'th-title-table': 'silver',
    'line-color': '#FFFFFF',
    'label-color-cadastre': '#C2C2C2',
    'hr-border-color': 'rgba(0, 0, 0, 0.1);',
    'table-add-bg': 'background: rgb(0, 0, 0, 0.2)',
    'nav-tab-border-color': '#dee2e6',
    'title-label-color': '#DED615',
    'image-demanda': "url('/assets/demanda.png')",
    'image-tensao': "url('/assets/tensao.png')",
    'image-temperatura': "url('/assets/temperatura.png')",
    'image-concessionaria-on': "url('/assets/concessionaria-on.png')",
    'image-concessionaria-off': "url('/assets/concessionaria-off.png')",
    'image-caldeira-on': "url('/assets/caldeira-on.png')",
    'image-caldeira-off': "url('/assets/caldeira-on.png')",
    'image-chiller-on': "url('/assets/chiller-on.png')",
    'image-chiller-off': "url('/assets/chiller-on.png')",
    'image-gerador-on': "url('/assets/gerador-on.png')",
    'image-gerador-off': "url('/assets/gerador-on.png')",
    'image-painel-solar': "url('/assets/painel-solar.png')",
    'image-painel-solar-on': "url('/assets/painel-solar-on.png')",
    'image-painel-solar-alarm': "url('/assets/logo-alarm.png')",
    'image-biodigestor': "url('/assets/biodigestor.png')",
    'image-biodigestor-on': "url('/assets/biodigestor-on.png')",
    'image-biodigestor-alarm': "url('/assets/logo-alarm.png')",
    'image-bomba-calor': "url('/assets/bomba-calor.png')",
    'image-bomba-calor-on': "url('/assets/bomba-calor-on.png')",
    'image-bomba-calor-alarm': "url('/assets/logo-alarm.png')",
    'image-planta-co2': "url('/assets/planta-co2.png')",
    'image-planta-co2-on': "url('/assets/planta-co2-on.png')",
    'image-planta-co2-alarm': "url('/assets/logo-alarm.png')",
    'image-planta-n2': "url('/assets/planta-n2.png')",
    'image-planta-n2-on': "url('/assets/planta-n2-on.png')",
    'image-planta-n2-alarm': "url('/assets/logo-alarm.png')",
    'image-subestacao': "url('/assets/subestacao.png')",
    'image-subestacao-on': "url('/assets/subestacao-on.png')",
    'image-subestacao-alarm': "url('/assets/logo-alarm.png')",
    'image-tb-alarm': "url('/assets/logo-alarm.png')",
    'image-ac-alarm': "url('/assets/logo-alarm.png')",
    'image-cc-alarm': "url('/assets/logo-alarm.png')",
    'image-mn-alarm': "url('/assets/logo-alarm.png')",
    'image-bm-alarm': "url('/assets/logo-alarm.png')",
    'image-pr-alarm': "url('/assets/logo-alarm.png')",
    'image-op-alarm': "url('/assets/logo-alarm.png')",
    'image-tb-on': "url('/assets/turbina-on.png')",
    'image-ac-on': "url('/assets/Arcondicionado-on.png')",
    'image-cc-on': "url('/assets/Newconcessionaria-on.png')",
    'image-mn-on': "url('/assets/manutencao-on.png')",
    'image-bm-on': "url('/assets/biomassa-on.png')",
    'image-pr-on': "url('/assets/processo-on.png')",
    'image-op-on': "url('/assets/operacional-on.png')",
    'image-tb': "url('/assets/turbina.png')",
    'image-ac': "url('/assets/Arcondicionado.png')",
    'image-cc': "url('/assets/Newconcessionaria.png')",
    'image-mn': "url('/assets/manutencao.png')",
    'image-bm': "url('/assets/biomassa.png')",
    'image-pr': "url('/assets/processo.png')",
    'image-op': "url('/assets/operacional.png')",
    'image-ca': "url('/assets/caldeira-on-light.png')",
    'image-ca-on': "url('/assets/ca-on.png')",
    'image-ca-alarm': "url('/assets/logo-alarm.png')",
    'image-ch': "url('/assets/chiller-on-light.png')",
    'image-ch-on': "url('/assets/ch-on.png')",
    'image-ch-alarm': "url('/assets/logo-alarm.png')",
    'image-gr': "url('/assets/gerador-on-light.png')",
    'image-gr-on': "url('/assets/gr-on.png')",
    'image-gr-alarm': "url('/assets/logo-alarm.png')",
    'image-ba': "url('/assets/bateria.png')",
    'image-ba-on': "url('/assets/bateria-on.png')",
    'image-ba-alarm': "url('/assets/logo-alarm.png')",
    'image-ec': "url('/assets/CO2.png')",
    'image-ec-on': "url('/assets/CO2-on.png')",
    'image-ec-alarm': "url('/assets/logo-alarm.png')",
    'image-co': "url('/assets/cogeracao.png')",
    'image-co-on': "url('/assets/cogeracao-on.png')",
    'image-co-alarm': "url('/assets/logo-alarm.png')",
    'image-em': "url('/assets/em.png')",
    'image-em-on': "url('/assets/em-on.png')",
    'image-em-alarm': "url('/assets/logo-alarm.png')",
    'image-sm': "url('/assets/sm.png')",
    'image-sm-on': "url('/assets/sm-on.png')",
    'image-sm-alarm': "url('/assets/logo-alarm.png')",
    'image-tt': "url('/assets/totalizador.png')",
    'image-tt-on': "url('/assets/totalizador-on.png')",
    'image-tt-alarm': "url('/assets/logo-alarm.png')",
    'iconegrafico': "url('/assets/iconegrafico.png')",
    'card_grafico': "url('assets/grafico.png')",
    'card_grafico2': "url('./assets/grafico.png')",  // Com ponto e barra
    'card_grafico3': "url(assets/grafico.png)",      // Sem aspas internas
};

export const lightTheme = {
    'main-bg-color': '#E5E5E2',
    'color-yellow-pri': '#DED615',
    'color-yellow-sec': 'rgb(222,214,21,0.6)',
    'color-dark': '#4A4A4A',
    'font-color': '#847F64',
    'border-line-color': 'rgb(0,0,0,0.3)',
    'background-title': 'rgb(0, 0, 0, 0.5)',
    'card-title-color': '#847F64',
    'bar-chart-title-color': '#847F64',
    'bar-chart-font-color': '#847F64',
    'box-chart-line': "rgb(0,0,0,0.3)",
    'box-table-bg': '#E5E5E2',
    'th-title-table': '#4A4A4A',
    'line-color': '#847F64',
    'label-color-cadastre': 'rgb(132,127,100, 0.7)',
    'hr-border-color': 'rgba(0, 0, 0, 0.7);',
    'table-add-bg': 'background: rgb(0, 0, 0, 0.06)',
    'nav-tab-border-color': '#847F64',
    'caldeira-on-image': "url('/assets/caldeira-on-light.png')",
    'title-label-color': '#847F64',
    'image-demanda': "url('/assets/demanda-light.png')",
    'image-tensao': "url('/assets/tensao-light.png')",
    'image-temperatura': "url('/assets/temperatura_light.png')",
    'image-concessionaria-on': "url('/assets/concessionaria-on-light.png')",
    'image-concessionaria-off': "url('/assets/concessionaria-off-light.png')",
    'image-caldeira-on': "url('/assets/caldeira-on-light.png')",
    'image-caldeira-off': "url('/assets/caldeira-on.png')",
    'image-chiller-on': "url('/assets/chiller-on-light.png')",
    'image-chiller-off': "url('/assets/chiller-on.png')",
    'image-gerador-on': "url('/assets/gerador-on-light.png')",
    'image-gerador-off': "url('/assets/gerador-on.png')",
    'image-painel-solar': "url('/assets/painel-solar.png')",
    'image-painel-solar-on': "url('/assets/painel-solar-on.png')",
    'image-painel-solar-alarm': "url('/assets/painel-solar-alarm.png')",
    'image-biodigestor': "url('/assets/biodigestor.png')",
    'image-biodigestor-on': "url('/assets/biodigestor-on.png')",
    'image-biodigestor-alarm': "url('/assets/biodigestor-alarm.png')",
    'image-bomba-calor': "url('/assets/bomba-calor.png')",
    'image-bomba-calor-on': "url('/assets/bomba-calor-on.png')",
    'image-bomba-calor-alarm': "url('/assets/bomba-calor-alarm.png')",
    'image-planta-co2': "url('/assets/planta-co2.png')",
    'image-planta-co2-on': "url('/assets/planta-co2-on.png')",
    'image-planta-co2-alarm': "url('/assets/planta-co2-alarm.png')",
    'image-planta-n2': "url('/assets/planta-n2.png')",
    'image-planta-n2-on': "url('/assets/planta-n2-on.png')",
    'image-planta-n2-alarm': "url('/assets/planta-n2-alarm.png')",
    'image-subestacao': "url('/assets/subestacao.png')",
    'image-subestacao-on': "url('/assets/subestacao-on.png')",
    'image-subestacao-alarm': "url('/assets/subestacao-alarm.png')",
    'card_grafico': "url('assets/card_grafico.png')",
    'iconegrafico': "url('/assets/iconegrafico.png')",

};

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    private isDark: boolean = true;
    constructor() { }

    toggleTheme() {
        if (this.isDark) {
            this.toggleLight();
            localStorage.setItem("theme", "light");
        } else {
            this.toggleDark();
            localStorage.setItem("theme", "dark");
        }
    }

    setDefaultTheme() {
        if (localStorage.getItem("theme") == null || localStorage.getItem("theme") == 'dark') {
            this.toggleDark();
        } else {
            this.toggleLight();
        }
    }

    toggleDark() {
        this.setTheme(darkTheme);
        this.isDark = true;
    }

    toggleLight() {
        this.setTheme(lightTheme);
        this.isDark = false;
    }

    private setTheme(theme: {}) {
        Object.keys(theme).forEach(k =>
            document.documentElement.style.setProperty(`--${k}`, theme[k])
        );
    }
}
